import { getChannelSingular } from '@at/formatter-utils/lib/channel-utils/channel.util'
import { asFormattedString } from '@at/formatter-utils/lib/number-utils/number.utils'
import { Channel } from '@at/sauron-platform-core'

export const ctaMessageBuilder = (totalResults?: number, channel = Channel.cars) => {
    const formattedTotalResults = asFormattedString(totalResults || 0)
    if (totalResults === 1) {
        return `Search 1 ${getChannelSingular(channel)}`
    } else if (totalResults && totalResults > 1) {
        return `Search ${formattedTotalResults} ${channel}`
    }
    return `Search ${channel}`
}
